module.exports = __webpack_public_path__ + "media/images/emblems/Eppenberg-blason-448c7818c3f221df9390fb3df01091ad.png";